import clsx from 'clsx'
import { ILoaderProps } from './types'
import styles from './styles.module.scss'

const Loader = ({ backgroundColor, className, color, size = 16, ...props }: ILoaderProps) => {
  const customStyle: { borderColor?: string; borderTopColor?: string } = {}
  if (backgroundColor) {
    customStyle.borderColor = backgroundColor
  }
  if (color) {
    customStyle.borderTopColor = color
  }

  return (
    <div style={{ fontSize: `${size}px` }} {...props}>
      <div
        className={clsx('mui-loader', styles.loader, className)}
        data-testid="mui-loader"
        style={Object.keys(customStyle).length ? customStyle : {}}
      />
    </div>
  )
}

export default Loader
